/* @flow strict */

import * as React from 'react';
import _ from 'lodash';

type PropsType = {
  showTickets: boolean,
  parts: [] | null
};

const EventPageDesignMenu = ({ showTickets, parts }: PropsType): React.Element<'div'> => {
  const _Header = React.useRef();
  const [active, setActive] = React.useState(0);

  window.onscroll = () => {
    const header = _Header.current; // document.getElementById('splash-header');
    const sticky = 190; // header.offsetTop + 120;

    if (header) {
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }
  };

  const _parts = _.size(parts) ? _.uniqBy(parts, 'type') : [];

  return (
    <div id="splash-header" className="splash-header show-navbar" ref={_Header}>
      <div className="pgwMenu">
        <div className="pm-viewMore">

          <div className="pm-viewMore" style={{ display: 'none' }}>
            <a href="#" className="">
              <span>●●●</span>
            </a>
            <ul style={{ display: 'none' }} />
          </div>
        </div>

        <div className="pm-dropDown" style={{ display: 'none' }}>
          <a href="#">
            <span className="icon" />
          </a>
        </div>

        <ul className="pm-links">
          <li>
            <a
              href="#home"
              className={active === 0 ? 'active' : ''}
              splash-to-section="#home"
              onClick={() => {
                setActive(0);
              }}
            >General Info</a>
          </li>
          {showTickets ?
            <li>
              <a
                href="#tickets"
                splash-to-section="#tickets"
                onClick={() => {
                  setActive(1);
                }}
              >Tickets</a>
            </li> :
            null
          }

          {parts ? _.map(
            _.sortBy(parts, (p: {}): number => p.placement_index),
            (p: {}, pi: number): React.Element<'li'> => {
            return (
              <li
                key={`TicketPreview-part-${pi}`}
              >
                <a
                  className={pi + 2 === active ? 'active' : ''}
                  href={`#${_.toLower(p.link_label).split(' ').join('')}${p.id}`}
                  onClick={() => {
                    setActive(pi + 2);
                  }}
                >{p.link_label}</a>
              </li>
            );
          }) : null}
        </ul>
      </div>
    </div>
  );
};

export default EventPageDesignMenu;
